module.exports = __webpack_public_path__ + "static/img/fz.a919de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/fz.jpg
// module id = RmSO
// module chunks = 1